import { IFolderPanelInfo } from "../../../interfaces/IFolderPanelInfo";
import { IPageSettings } from "../../../interfaces/IPageSettings";

export abstract class BaseFolderPanelHelper {
    shareableProperties: any
    constructor(protected folderPanelInfo: IFolderPanelInfo, protected currentDirectory: IPageSettings) { }

    protected getShareableProperties() {
        return {
            id: this.folderPanelInfo.folder.id,
            parentId: this.folderPanelInfo.folder.driveId,
            fileTitle: this.folderPanelInfo.folder.name,
            displayName: this.folderPanelInfo.folder.name,
            webUrl: this.currentDirectory.webUrl
        };
    }

    protected getShareableSharepointProperties() {
        return {
            ...this.getShareableProperties(),
            siteId: this.currentDirectory.siteId,
            siteDisplayName: this.currentDirectory.siteDisplayName
        };
    }
}

